import React from "react"
import "../styles/Signup.css"

class Signup extends React.Component {
  render() {
    return (
      <div>


<div id="SignupContainer">
    <div class="signupBox">
      <header>
        <h2>Instagram</h2>
        <p>Sign up to see photos and videos from your friends.</p>
        <button><i class="fab fa-facebook"></i>Log in with Facebook</button>
      </header>
      <div class="seperator">
        <hr>OR</hr>
      </div>
      <form action="#">
        <input type="text" name="email" placeholder="Mobile Number or Email"/>
        <input type="text" name="fullname" placeholder="Full Name"/>
        <input type="text" name="username" placeholder="Username"/>
        <input type="password" placeholder="Password"/>
        <button type="button" disabled>Sign up</button>
      </form>
      <footer>
        <p>
          By signing up, you agree to our <a href="#">Terms , Data Policy</a> and <a href="#">Cookies Policy</a> .
        </p>
      </footer>
    </div>
  </div>
  <div id="BottomContainer">
    <p>
      Have an account? <a href="#">Log in</a>
    </p>
  </div>
  <div id="AppsContainer">
    <p>Get the app.</p>
    <img src="https://i.postimg.cc/Vkm7D9Xd/appstore.png" alt="appstore"/>
    <img src="https://i.postimg.cc/R00gzMsm/playstore.png" alt="playstore"/>
  </div>
  <div id="LastContainer">
    <div class="links">
      <a href="#">ABOUT</a>
      <a href="#">HELP</a>
      <a href="#">PRESS</a>
      <a href="#">API</a>
      <a href="#">JOBS</a>
      <a href="#">PRIVACY</a>
      <a href="#">TERMS</a>
      <a href="#">LOCATIONS</a>
      <a href="#">TOP ACCOUNTS</a>
      <a href="#">HASH TAGS</a>
      <a href="#">LANGUAGE</a>
    </div>
    <div class="copyright">
      <p>&copy; 2020 INSTAGRAM SIGN UP PAGE CLONE</p>
    </div>
  </div>
  
      </div>
    )
  }
}
export default Signup